import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { ROUTES, COMMON } from '../../../constants'
import { TableCell, TableRow } from '@mui/material'
import PostLogin from '../../../layout/post-login'
import TaskService from '../../../services/task.service'
import { useMuiSnackbar } from '../../../hooks'
import {
  Title,
  Stats,
  MuiChip,
  TableWrapper,
  TableAction,
  Loader
} from '../../../components/'
import { StyledAdd } from './style'
import { Wrapper } from '../../common/style'

const TaskListPage = () => {
  const { SnackbarSuccess, SnackbarError } = useMuiSnackbar()
  const [gridLoader, setGridLoader] = useState(true)
  const [selectedRow, setSelectedRow] = useState({})
  // const [openConfirmation, setConfirmation] = useState(false)
  const [taskData, setTaskData] = useState([])

  const statsData = [
    {
      title: 'total tasks',
      count: taskData?.length
    },
    {
      title: 'completed tasks',
      count: taskData.filter(d => d.status === 'completed').length
      // color: 'success'
    },
    {
      title: 'in Progress tasks',
      count: taskData.filter(d => d.status === 'inProgress').length
      // color: 'warning'
    },
    {
      title: 'open tasks',
      count: taskData.filter(d => d.status === 'open').length
      // color: 'error'
    }
  ]

  const tableData = {
    title: 'task list',
    view: ROUTES.ROUTE_TASK_VIEW,
    edit: ROUTES.ROUTE_TASK_FORM,
    cols: [
      { title: 'task name' },
      { title: 'assigned to' },
      { title: 'due date' },
      { title: 'due time' },
      { title: 'status' }
    ],
    rows: taskData,
    srNo: true
  }

  const loadTutorialData = () => {
    TaskService?.getTaskList()
      .then(response => {
        setTaskData(response?.data?.reverse())
      })
      .catch(err => {
        SnackbarError(err)
      })
      .finally(() => {
        setGridLoader(false)
      })
  }

  const confirmationDeleteSubmit = () => {
    TaskService?.deleteTask(selectedRow?._id)
      .then(response => {
        loadTutorialData()
        SnackbarSuccess(selectedRow?.taskName, 'deleted')
      })
      .catch((err) => {
        SnackbarError(err)
      })
  }

  useEffect(() => {
    loadTutorialData()
  }, [])

  return (
    <PostLogin heading='Task' fixed>
      <Title
        // tabs={[
        //   {
        //     label: 'List',
        //     to: '',
        //     active: true
        //   },
        //   {
        //     label: 'Add New',
        //     to: ROUTES.ROUTE_TASK_FORM
        //   }
        // ]}
        primaryButton={{
          startAdornment: <StyledAdd />,
          title: 'add',
          to: ROUTES.ROUTE_TASK_FORM,
          size: 'small'
        }}
      />
      <Loader showLoader={gridLoader} animate/>
      <Wrapper loader={gridLoader}>
        <Stats data={statsData} loader={gridLoader} />
        <TableWrapper data={tableData} loader={gridLoader}>
          {tableData.rows.map((row, i) => {
            return (
              <TableRow hover role='checkbox' key={row?._id} >
                <TableCell align='center'>{i + 1}</TableCell>
                <TableCell>{row?.taskName}</TableCell>
                <TableCell>{row?.assignedTo?.name || row?.assignedTo?.firstName}</TableCell>
                <TableCell>{COMMON?.FULL_DATE(row?.dueDate)}</TableCell>
                <TableCell>{row?.dueTime}</TableCell>
                <TableCell>
                  <MuiChip
                    label={
                      COMMON?.VAL_TO_LABEL('TASK_STATUS', row, 'status')
                    }
                    size='small'
                    color={row?.status === 'completed' ? 'success' : row?.status === 'open' ? 'error' : row?.status === 'inProgress' ? 'warning' : 'primary'}
                  />
                </TableCell>
                <TableCell align='center'>
                  <TableAction size='small' to={`${tableData?.view}/${row._id}`} title='View' type='view' />
                  <TableAction size='small' to={`${tableData?.edit}/${row._id}`} title='Edit' type='edit' />
                  <TableAction
                    size='small'
                    title='Delete'
                    message={`Are you sure you want to delete this Task : ${selectedRow?.taskName}?`}
                    row={row}
                    onClick={() => { setSelectedRow(row) }}
                    onSuccess={confirmationDeleteSubmit}
                    type='delete'
                  />
                </TableCell>
              </TableRow>
            )
          })}
        </TableWrapper>
      </Wrapper>
    </PostLogin>
  )
}

TaskListPage.propTypes = {
  setAgentDataPage: PropTypes.func,
  setAgentDataLimit: PropTypes.func,
  agentDataPage: PropTypes.func,
  agentDataLimit: PropTypes.func
}

TaskListPage.displayName = 'ListPage'

export default TaskListPage
